let apiOrigins = {
  localhost: {
      paywall: 'http://localhost:64184',
      ingresar: 'http://localhost:17927'
  },
  qa: 'https://qa-api-{app}.lanacion.com.ar',
  pre: 'https://pre-api-{app}.lanacion.com.ar',
  beta: 'https://beta-api-{app}.lanacion.com.ar',
  prod: 'https://api-{app}.lanacion.com.ar'
}

let lnOrigins = {
  localhost: 'https://swg-ln9.lanacion.com.ar',
  qa: 'https://swg-ln9.lanacion.com.ar',
  pre: 'https://www.lanacion.com.ar',
  beta: 'https://www.lanacion.com.ar',
  prod: 'https://www.lanacion.com.ar', 
}

let domain = window.location.origin.includes('localhost') ? 'localhost' : '.lanacion.com.ar';
let lnUrl = lnOrigins[getEnvironment()];

function getApiEnvironment(api) {
  
  if (window.location.origin.includes('localhost')) {
      return (api === 'paywall') ? apiOrigins.localhost.paywall : apiOrigins.localhost.ingresar;
  }
  if (window.location.origin.includes('qa') || window.location.origin.includes('swg-ln9')) {
      return apiOrigins.qa.replace('{app}', api);
  }
  if (window.location.origin.includes('pre')) {
      return apiOrigins.pre.replace('{app}', api);
  }
  if (window.location.origin.includes('beta')) {
      return apiOrigins.beta.replace('{app}', api);
  }

  return apiOrigins.prod.replace('{app}', api); 
}

function getEnvironment(){
  if (window.location.origin.includes('qa')) {
    return 'qa';
  }
  if (window.location.origin.includes('pre')) {
    return 'pre';
  }
  if (window.location.origin.includes('beta')) {
    return 'beta';
  }
  if(window.location.origin.includes('localhost')) {
    return 'localhost';
  }
  return 'prod';
}

module.exports = {
  cookies: [
      'usuariosexo',
      'usuarioemail',
      'usuarioanio',
      'usuarioDetalleClubNacion',
      'UsuarioDetalleGuid',
      'UsuarioDetalleNick',
      'UsuarioId',
      'UsuarioUsuario',
      'usuario%5Fusuario',
      'usuarioLogTkn',
      'cookieLogin',
      'syncLfLN',
      'tieneClub',
      'Provinciaid',
      'Paisid',
      'LNPreferencias',
      'Crm_id',
      'ProductoPremiumId',
      'token',
      'xvalue',
      'TokenJWT'
  ],
  swgPreventLoginCookie : "SWGPreventLogin",
  dominio: domain,
  expirationcookie: '8640000',
  api: {
      login: getApiEnvironment('ingresar'),
      paywall: getApiEnvironment('paywall')
  },
  lnUrl: lnUrl,
  SitioId: '1'
}




// WEBPACK FOOTER //
// ./~/@ln/registracionlibs/src/core/config.js